import React, { Fragment, useState } from "react";
import {
  AppInsightsContext,
  AppInsightsErrorBoundary,
} from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../utils/AppInsights";
import { Outlet } from "react-router-dom";
import Header from "../Layout/Header/Header";
import Error from "./Error";

const Layout = (props) => {

  return (
    <AppInsightsErrorBoundary
      onError={() => <Error />}
      appInsights={reactPlugin}
    >
      <AppInsightsContext.Provider value={reactPlugin}>
     
        <main className="mainContent">
          <Header IsShowToggle={true} />
          <Outlet />
        </main>
      </AppInsightsContext.Provider>
    </AppInsightsErrorBoundary>
  );
};

export default Layout;
